'use client';

import { faCalendarDays } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import Link from 'next/link';

import { Button } from '@/components/ui/button/button.component';
import { useAgendamentoNavigation } from '@/hooks/navigation/use-agendamento-navigation.hook';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface ProfessionalScheduleRedirectButtonProps {
  professionalId: string;
  className?: string;
}

export function ProfessionalScheduleRedirectButton({
  professionalId,
  className,
}: ProfessionalScheduleRedirectButtonProps) {
  const { buildLink } = useAgendamentoNavigation();

  return (
    <Button
      startIcon={faCalendarDays}
      startIconSize="1x"
      startIconClassName="w-4 h-4 text-base"
      className={className}
      data-testid={DataTestIdEnum.PROFESSIONAL_PROFILE_SCHEDULE_BUTTON_HEADER}
      data-analytics-event={AnalyticsEnum.PROFESSIONAL_PROFILE_SELECT_REDIRECT}
      asChild
    >
      <Link prefetch={false} href={buildLink({ path: `/professionals/${professionalId}/` })}>
        Consultas e horários
      </Link>
    </Button>
  );
}
